import React, { useEffect, useState } from 'react';
import Item from '../../components/Form/Item';
import { Checkbox, Row, Col, message } from 'antd';
import { ErrorMessage, useFormikContext } from 'formik';
import axios from '../../util/Api';
import { LoadingOutlined } from '@ant-design/icons';

const SkillsForm = (props) => {
  const formik = useFormikContext();
  const [loading, setLoading] = useState(true);
  const [skills, setSkills] = useState({});

  useEffect(() => {
    fetchSkills();
  }, []);

  const fetchSkills = () => {
    setLoading(true);
    const url = `/skills/list`;
    axios.get(url).then(({ data }) => {
      setSkills(data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat daftar kompetensi");
    });
  }

  const handleChange = (values) => {
    formik.setFieldValue("skills", values);
  }

  return (
    <Item name="Kompetensi" required>
      <Checkbox.Group style={{width: "100%"}} defaultValue={formik.values.skills} onChange={handleChange}>
        {loading ? (
          <>
            <LoadingOutlined className="gx-mr-2" /> Sedang memuat daftar kompetensi
          </>
        ) : (
          <Row>
            {Object.keys(skills).map(category => {
              if (category === "K3") {
                return (
                  <Col span={24} key={`categories-${category}`} className="gx-mb-3">
                    <h5>{category}</h5>
                    <Row>
                      {skills[category].map((skill, key) => {
                        return (
                          <Col md={12} xs={24} key={`skill-${skill.id}`}>
                            <div className="gx-mb-1">
                              <Checkbox value={skill.id} key={`skills-${skill.id}`}>{skill.name}</Checkbox>
                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                );
              }

              return (
                <Col md={8} xs={24} key={`categories-${category}`} className="gx-mb-3">
                  <h5>{category}</h5>
                  {skills[category].map(skill => {
                    return (
                      <div className="gx-mb-1" key={`skill-${skill.id}`}>
                        <Checkbox value={skill.id} key={`skills-${skill.id}`}>{skill.name}</Checkbox>
                      </div>
                    );
                  })}
                </Col>
              );
            })}
          </Row>
        )}
      </Checkbox.Group>
      <ErrorMessage component="div" name="skills" className="gx-mt-2 gx-text-red" />
      <div className="gx-mt-2 gx-text-blue">
        Pilih sesuai dengan kompetensi yang Anda dimiliki, pastikan yang Anda pilih benar dan bisa dipertanggungjawabkan
      </div>
    </Item>
  );
}

export default SkillsForm;